/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-width{max-width:300px!important;width:100%!important}  .custom-margin{margin-left:-61px}  .isinvalid{border:1px solid red!important;background-color:red!important}.form-control-static[_ngcontent-%COMP%]{word-wrap:break-word;white-space:normal}.is-invalid[_ngcontent-%COMP%]{border-color:#dc3545!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-treatment-spray/request-planning-treatment-spray.component.css.shim.ngstyle.js.pre-build-optimizer.js